export default "__VITE_ASSET__D57PQ93x__"